import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=b739e622&scoped=true"
var script = {}
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=b739e622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b739e622",
  null
  
)

export default component.exports